import { PropsWithChildren } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { Stack } from './Stack';
import { Heading } from './Heading';
import { ActionButtons } from './ActionButtons';
import { Button } from './Button';
import { Modal } from './Modal';

type Props = PropsWithChildren<{
  open: boolean;
  title: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  yesButtonLabel?: string;
  noButtonLabel?: string;
}>;

export function AlertModal({
  open,
  title,
  onClose,
  onConfirm,
  yesButtonLabel = 'Ja, ich bin sicher',
  noButtonLabel = 'Back',
  children,
}: Props): React.ReactElement {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        <Stack className="items-center text-center text-gray-500 w-full">
          <ExclamationTriangleIcon className="h-7 w-7" />
          <Heading variant="h5">WARNUNG</Heading>
        </Stack>
      }
      description={title}
      className="max-w-prose"
    >
      <div className="text-2xl text-pretty antialiased">{children}</div>

      <ActionButtons className="mt-10 items-center">
        <Button onClick={onConfirm}>{yesButtonLabel}</Button>
        <Button onClick={onClose} fill="outlined">
          {noButtonLabel}
        </Button>
      </ActionButtons>
    </Modal>
  );
}
